// extracted by mini-css-extract-plugin
module.exports = {"TitleCard":"TitleCard_TitleCard__1x7cY","light":"TitleCard_light__38RT2","mapTitle":"TitleCard_mapTitle__3k_BZ","mapByline":"TitleCard_mapByline__3Q2p-"};